import { type QueryHookOptions, useQuery } from "@apollo/client";
import { CurrentUserQuery } from "../graphql/queries";

export const useCurrentUserQuery = (options?: QueryHookOptions) => {
  return useQuery(CurrentUserQuery, options);
};
